(function() {

    if ($('#frm-eventSettingsForm-date').length == 0 || $('#frm-eventSettingsForm-date_end').length == 0) {
        return 0;
    }

    var $prices = $('#day-prices');
    var $limits = $('#day-limits');


    var start = $('#frm-eventSettingsForm-date');
    var end = $('#frm-eventSettingsForm-date_end');

    $(document).on('change', '#frm-eventSettingsForm-date', updateDays);
    $(document).on('change', '#frm-eventSettingsForm-date_end', updateDays);



    function updateDays () {
        startVal = start.val().split('.');
        endVal = end.val().split('.');
        var startDate = new Date(startVal[1]+'.'+startVal[0]+'.'+startVal[2]);
        var endDate = new Date(endVal[1]+'.'+endVal[0]+'.'+endVal[2]);

        var difference = endDate - startDate;

        var len = difference/86400000;

        $prices = $('#day-prices');
        $limits = $('#day-limits');

        render(startDate, len);
    }

    function render (date, num) {

        $prices.empty();
        $limits.empty();
        var currentDate = new Date();
        var helpDate = new Date(date.toString());

        for (i = 0; i <= num; i++) {
            currentDate =  date.setDate(date.getDate()+i);
            date.setDate(helpDate.getDate());
            write(currentDate);
        }

        $(document).trigger('change:dom');

    }

    function write (date) {
        var cd = new Date(date);

        var elemP = '<div class="form-group" data-show-if="entrance!=free">' +
                        '<label for="price_1465077600" class="control-label col-md-4">Cena ' + cd.getDate() + '. ' + parseInt(1+cd.getMonth()) + '.</label>' +
                        '<div class="col-md-8 form-inline">' +
                            '<div class="input-group">' +
                                '<input name="prices[]" class="form-control"><span class="input-group-addon">Kč</span>' +
                            '</div>' +
                        '</div>' +
                    '</div>';

        var elemL = '<div class="form-group" data-show-if="capacity==limited">'+
            '<label class="control-label col-md-5">Počet lidí ' + cd.getDate() + '. ' + parseInt(1+cd.getMonth()) + '.</label>'+
            '<div class="col-md-7 form-inline">'+
            '<input name="limits[]" class="form-control">'+
            '</div>'+
            '</div>';

        $prices.append(elemP);
        $limits.append(elemL);
    }



})();